import { getSavedState } from "../local-storage";
import { requiredParam } from "@utils/func";

const mapDefaultStateFromSchema = ({
  moduleName = requiredParam("moduleName"),
  stateSchema = requiredParam("stateSchema"),
} = {}) => {
  const defaultState = {};

  Object.keys(stateSchema).forEach((key) => {
    defaultState[key] = stateSchema[key].saveToLocalStorage
      ? getSavedState(`${moduleName}.${key}`) || stateSchema[key].default
      : stateSchema[key].default;
  });
  return defaultState;
};

export { mapDefaultStateFromSchema };
